import clsx from 'clsx';
import { Avatar, InputCheckbox, TextHtml } from 'ui';
import { stripHtml } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React from 'react';

const UnitItem = ({ t, isEditorial, selected, disabled, guid, name, book, level, discipline, editedbBy, onChangeSelected }) => {
  return (
    <div className={clsx('unit-item', { 'unit-item--disabled': disabled, 'unit-item--selected': selected })}>
      <div className="unit-item__container">
        <div className="unit-item__top">
          <div className="unit-item__top-left">
            <div className="unit-item__check">
              {/* Hidden label gives the checkbox an accessible name; the visible name is HTML
                  rendered separately, so we pass the plain-text name here. */}
              <InputCheckbox
                checked={selected || disabled}
                label={<span className="sr-only">{stripHtml(name)}</span>}
                onChange={disabled ? null : () => onChangeSelected(!selected, guid)}
              />
            </div>
            <div className="unit-item__name">{<TextHtml text={name} />}</div>
            <span className="unit-item__editorial">{isEditorial ? `(${t('course:Editorial version')})` : ''}</span>
          </div>
          <div className="unit-item__top-right">
            <div className="unit-item__info-unit">
              <span>{level}</span> - <span>{discipline}</span>
            </div>
          </div>
        </div>
        <div className="unit-item__bottom">
          <div className="unit-item__book">{book}</div>
          {editedbBy && (
            <div className="unit-item__edited-by">
              <div className="unit-item__edited-by-text">
                {t('course:Edit by')} <span>{editedbBy.name}</span>
              </div>
              <div className="unit-item__edited-by-avatar">
                <Avatar size="xs" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

UnitItem.propTypes = {
  book: PropTypes.string,
  disabled: PropTypes.bool,
  discipline: PropTypes.string,
  editedbBy: PropTypes.object,
  guid: PropTypes.string,
  isEditorial: PropTypes.bool,
  level: PropTypes.string,
  name: PropTypes.string,
  onChangeSelected: PropTypes.func,
  selected: PropTypes.bool,
  t: PropTypes.func,
};

UnitItem.defaultProps = {
  selected: false,
  disabled: false,
  onChangeSelected: () => {},
};

export default UnitItem;
